import {createStore} from "vuex";
import router from '../router/router'

const axios = require('axios');

let cancelTokenSource,
    cancelTokenSourceAggregates;

// import mockData from "../assets/mockData.js"
function sortStrings(a, b) {
    if (a.toLowerCase() < b.toLowerCase()) {
        return -1
    } else if (a.toLowerCase() > b.toLowerCase()) {
        return 1
    }
    return 0
}

const store = createStore({
    state() {
        return {
            //Data that will be filled uw with the fetched data
            data: {},
            panelOpen: false,
            searchables: [],
            filters: [],
            aggregatesData: [],
            //Will be filled up when the user checks boxes
            activeSearchables: [],
            activeFilters: [],
            activeChefs: [],
            cancelToke: null,
            activeCategories: [],
            activePrograms: [],
            activeBlog: [],


            //Default sorting, can be null since we initialize data anyways
            sorting: '',
            baseURL: '/ajax/search',
            //This searchQuery will be used when fetching data
            searchQuery: '',
            //Can be used to show spinners
            // -Pending will be set when retrieving data
            // -Error will be set when there is an error fetching data
            fetchState: {
                pending: false,
                error: null,
            },
            //Will be used for pagination
            page: 1,
            //User input
            text: '',
            setTimeoutObject: null,
            activeTab: false,
            shouldChangeUrl: false,
        }
    },
    getters: {
        data: (state) => {
            return {...state.data}
        },

        aggregatesData: (state) => {
            return {...state.aggregatesData}
        },

        filters: (state) => {
            return state.data.filters?.filter(item => item.title)
        },
        panelOpen: (state) => {
            return state.panelOpen;
        },

        url: (state) => {
            return state.url
        },

        resultTitle: (state, getters) => {
            let title = null;
            // if (getters.searchText) title = getters.searchText
            // const filters = state.activeFilters.map(filterAndCategories => filterAndCategories[1].join(', '));
            // if (filters.length > 0) title = `${(title ? title + ', ' : '')}${filters.join(', ')}`;
            title = `${state.data?.copy?.label_results} ${title ? '"' + title + '"' : ''}`
            return title
        },
        tabs: (state) => state.data?.tabs,
        activeTab: (state) => state.activeTab,
        results: (state) => {
            const total = state.data?.results
            const searchables = state.data?.searchables
            if (!total) return []
            const resultInType = [];

            total.forEach(result => {
                const idx = resultInType.findIndex(typeAndResult => typeAndResult[0].type === result.type)
                if (idx === -1) {
                    const searchable = searchables.find(searchable => searchable.slug === result.type)
                    resultInType.push([{
                        title: searchable.title,
                        type: result.type
                    }, [{...result}]])

                } else {

                    resultInType[idx][1].push({...result})

                }
            })
            return resultInType
        },

        activeFilters: (state) => [...state.activeFilters],
        activeCategories: (state) => [...state.activeCategories],
        activeChefs: (state) => [...state.activeChefs],
        activePrograms: (state) => [...state.activePrograms],
        activeBlog: (state) => [...state.activeBlog],
        activeSearchables: (state) => [...state.activeSearchables],

        searchables: (state) => {
            if (state.searchables) {
                return [...state.searchables]
            } else {
                return []
            }
        },
        searchText: (state) => {
            return state.text
        },

        searchPlaceholder: (state) => {
            return state.data?.copy?.label_filter_search || ''
        }
    },
    actions: {
        /**
         * Will try to get the params out of the URL, afterwards will get data
         * After the API call it wil call the buildURL mutation
         * @param ctx
         * @param {Object} urlParams Default is empty
         */
        initialize(ctx, urlParams) {
            if (urlParams) {
                ctx.dispatch('parseURL', urlParams).then();
            }

            //Get the data
            ctx.dispatch('getAggregates');
            ctx.dispatch('getData')
                    .then(() => {
                        //Build the URL again since the user might have typed in wrong slugs in the URL.
                        //Building the URL again will remove these wrong slugs
                        ctx.commit('buildURL')
                    })
        },

        /**
         * Parse the URL to get the input text, searchables, filters, sorting and page
         * @param ctx
         * @param urlParams
         */
        parseURL(ctx, urlParams) {
            if (urlParams.searchables) {
                if (urlParams.searchables === 'in-alle') {
                    ctx.commit('emptySearchables')
                } else {
                    const searchables = urlParams.searchables.split(',')
                    searchables.forEach(searchable => ctx.commit('pushSearchable', searchable))
                }
            }

            if (urlParams.q) {
                ctx.commit('setText', urlParams.q)
                delete urlParams.q
            }

            if (urlParams.page) {
                const number = parseInt(urlParams.page)
                if (number) {
                    ctx.commit('setPage', number)
                }
                delete urlParams.page
            }

            if (urlParams.sort) {
                ctx.commit('setSorting', urlParams.sort)
                delete urlParams.sort
            }

            if (urlParams.categories) {
                if (urlParams.categories === 'alle-categorieen') {
                    ctx.state.activeFilters = ctx.state.activeFilters.filter(filter => filter[0] !== 'category')
                } else {
                    const categories = urlParams.categories.split(',');
                    categories.forEach(category => {
                        ctx.commit('pushFilter', {slug: category, parent: 'category'});
                        ctx.commit('pushCategory', category);
                    })
                }
            }
            if (urlParams.chefs) {
                if (urlParams.chefs === 'alle-chefs') {
                    ctx.state.activeFilters = ctx.state.activeFilters.filter(filter => filter[0] !== 'chef')
                } else {
                    const chefs = urlParams.chefs.split(',')
                    chefs.forEach(category => {
                        ctx.commit('pushFilter', {slug: category, parent: 'chef'});
                        ctx.commit('pushChef', category);
                    })
                }
            }
            if (urlParams.programs) {
                if (urlParams.programs === 'alle-programmas') {
                    ctx.state.activeFilters = ctx.state.activeFilters.filter(filter => filter[0] !== 'program')
                } else {
                    const programs = urlParams.programs.split(',')
                    programs.forEach(category => {
                        ctx.commit('pushFilter', {slug: category, parent: 'program'});
                        ctx.commit('pushProgram', category);
                    })
                }
            }
        },

        /**
         * Pushes or pops a searchable from the activeSearchable state
         * Retrieves data afterwards
         * @param ctx
         * @param {object} searchable
         */
        updateSearchable(ctx, searchable) {


            if (ctx.state.activeSearchables.length <= 0) {
                ctx.commit('setTab', {})
            }
            if (searchable.active) {

                // if we have recipe with video we disable the normal recipe
                if(searchable.slug === 'recipe-with-video') {
                    ctx.commit('popSearchable', 'recipe');
                }

                // if we have recipe without video we disable the recipe with video
                if(searchable.slug === 'recipe') {
                    ctx.commit('popSearchable', 'recipe-with-video');
                }

                ctx.commit('pushSearchable', searchable.slug)
            } else {

                ctx.commit('popSearchable', searchable.slug)
                if (ctx.state.activeTab.slug === searchable.slug) {
                    ctx.commit('setTab', {})
                }
            }

            // always reset the pager if the searchable changes
            ctx.commit('setPage', 1)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')

            //Get the aggregates. Whit this data we can update the filter items total count
            ctx.dispatch('getAggregates')

            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },


        /**
         * Empty the activeSearchables states and pushes the given searchable
         * Retrieves data afterwards
         * @param ctx
         * @param {object} searchable
         */
        selectOneSearchable(ctx, searchable) {
            ctx.commit('emptySearchables')
            ctx.commit('pushSearchable', searchable.slug)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')
            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },

        /**
         * Either pushes or pops the given filter from the activeFilters state
         * Retrieves data afterwards
         * @param ctx
         * @param {object} filter
         */
        update(ctx, filter) {
            if (filter.active) {
                ctx.commit('pushFilter', {
                    slug: filter.slug,
                    parent: filter.parent
                })
            } else {
                ctx.commit('popFilter', {
                    slug: filter.slug,
                    parent: filter.parent
                })
            }

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')
            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },

        updateCategory(ctx, category) {
            if (category.active) {
                ctx.commit('pushCategory', category.slug)
            } else {
                ctx.commit('popCategory', category.slug)
            }

            ctx.commit('setPage', 1)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')

            //Get the aggregates. Whit this data we can update the filter items total count
            ctx.dispatch('getAggregates')

            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },
        updateChef(ctx, chef) {
            if (chef.active) {
                ctx.commit('pushChef', chef.slug)
            } else {
                ctx.commit('popChef', chef.slug)
            }

            ctx.commit('setPage', 1)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')

            //Get the aggregates. Whit this data we can update the filter items total count
            ctx.dispatch('getAggregates')

            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },
        updateProgram(ctx, program) {
            if (program.active) {
                ctx.commit('pushProgram', program.slug)
            } else {
                ctx.commit('popProgram', program.slug)
            }

            ctx.commit('setPage', 1)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')

            //Get the aggregates. Whit this data we can update the filter items total count
            ctx.dispatch('getAggregates')

            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },
        updateBlog(ctx, blog) {
            if (blog.active) {
                ctx.commit('pushBlog', blog.slug)
            } else {
                ctx.commit('popBlog', blog.slug)
            }

            ctx.commit('setPage', 1)

            //Build the URL so the user sees the change instantly
            ctx.commit('buildURL')

            //Get the aggregates. Whit this data we can update the filter items total count
            ctx.dispatch('getAggregates')

            //Get the data. We could build the URL again afterwards.
            ctx.dispatch('getData')
        },

        async getAggregates(ctx) {
            return;
            //Build the searchQuery
            ctx.commit('buildQuery')

            ctx.commit('setFetchStateError', '');

            if(cancelTokenSourceAggregates) {
                cancelTokenSourceAggregates.cancel();
            }
            cancelTokenSourceAggregates = axios.CancelToken.source();
            try {
                const res = await axios.get(`${ctx.state.baseURL}/aggregates${ctx.state.searchQuery}`, {
                    cancelToken: cancelTokenSourceAggregates.token
                });
                ctx.commit('setAggregatesData', res.data)

                // ctx.dispatch('checkFilters')

                return res.data
            } catch (error) {
                ctx.commit('setFetchStateError', error.message)
                return null
            }
        },

        /**
         * Gets data from the api.
         * Will also set the fetchState
         * In case of error, will catch error and set fetchState.error with the error message
         * @param ctx
         * @returns {Promise<Object>}
         */
        async getData(ctx) {
            //Build the searchQuery
            ctx.commit('buildQuery')
            //Set the fetchState in case we want to show loading spinners,...
            ctx.commit('setFetchStatePending', true)
            ctx.commit('setFetchStateError', '')

            const event = new Event('start-search');
            document.querySelector('[data-search-panel]').dispatchEvent(event);

            if(cancelTokenSource) {
                cancelTokenSource.cancel();
            }
            cancelTokenSource = axios.CancelToken.source();
            try {
                const res = await axios.get(`${ctx.state.baseURL}${ctx.state.searchQuery}`, {
                    cancelToken: cancelTokenSource.token
                });

                ctx.commit('setData', res.data)
                //Set fetchState.pending to false since we are done loading
                ctx.commit('setFetchStatePending', false)

                const event = new Event('search-result-in');
                document.querySelector('[data-search-panel]').dispatchEvent(event);

                const sorting = res.data.sorting.find(sorting => sorting.active)
                if (sorting) ctx.commit('setSorting', sorting.slug)

                const page = res.data.pagination?.pages.find(page => page.active)
                if (page) ctx.commit('setPage', page.number)

                // const tab = res.data?.tabs.find(tab => tab.data)
                //
                // if (tab) ctx.commit('setTab', tab)
                // if (!tab && res.data?.tabs?.length > 0) ctx.commit('setTab', res.data?.tabs[0])

                ctx.dispatch('checkFilters')

                return res.data
            } catch (error) {
                //Pending state to false and set the error message
                ctx.commit('setFetchStateError', error.message)
                return null
            }
        },
        /**
         * Set sorting slug as sorting state and retrieves data
         * @param ctx
         * @param {string} slug
         */
        setSorting(ctx, slug) {
            ctx.commit('setPage', 1)
            ctx.commit('setSorting', slug)
            ctx.commit('buildURL')
            ctx.dispatch('getData')
        },

        setTab(ctx, slug) {
            ctx.commit('setTab', slug)
            ctx.commit('buildURL')
            ctx.dispatch('getData')
        },

        checkFilters(ctx) {
            const filters = ctx.state.data?.filters.filter(filter => filter.title).map(filter => filter.slug)

            if (!filters.includes('category')) ctx.state.activeCategories = []
            if (!filters.includes('celeb')) ctx.state.activeChefs = []
            if (!filters.includes('program')) ctx.state.activePrograms = []
            if (!filters.includes('blog')) ctx.state.activeBlog = []

            // ctx.commit('setActiveFilters', activeFilters)
            ctx.commit('buildURL')
        },

        /***
         * Gets the history state and sets the current state with the retrieved history
         * @param ctx
         */
        setHistoryState(ctx, urlParams) {
            ctx.dispatch('parseURL', urlParams)
            //Retrieve the data again, could build the URL afterwards
            ctx.dispatch('getData')
        },

        setPanelOpen(ctx, opened) {
            ctx.commit('setPanelOpen', opened);
        },

        setShouldChangeUrl(ctx, value) {
            ctx.commit('setShouldChangeUrl', value)
            ctx.commit('buildURL')
        },


        /**
         * Set the current page number
         * @param ctx
         * @param {number} page
         */
        setPage(ctx, page) {
            ctx.commit('setPage', page)
            ctx.commit('buildURL')
            ctx.dispatch('getData')
        },

        updateText(ctx, text) {
            // Whenever the user changes the search term, set the page back to 1
            ctx.commit('setPage', 1)
            ctx.commit('setText', text)
            ctx.commit('buildURL')

            // Add a delay before firing a call to the backend, to avoid unnecessary
            // load when typing a search term
            ctx.dispatch('queueGetData', 300)
        },

        queueGetData(ctx, ms) {
            if (ctx.state.setTimeoutObject) clearTimeout(ctx.state.setTimeoutObject)
            ctx.state.setTimeoutObject = setTimeout(() => {
                ctx.dispatch('getData')
            }, ms)
        }
    },
    mutations: {
        /**
         * Sets the data state
         * @param state
         * @param {object} newData
         */
        setData(state, newData) {
            const {searchables, filters} = newData
            state.data = {...newData}
            state.searchables = []
            state.searchables = [...searchables]
            state.filters = []
            state.filters = [...filters]
        },

        /**
         * Sets the data for the aggregates
         * @param state
         * @param newData
         */
        setAggregatesData(state, newData) {
            state.aggregatesData = newData;
        },

        /**
         * Empties the activeSearchables state
         * @param state
         */
        emptySearchables(state) {
            state.activeSearchables = []
        },

        /**
         * Pushes a searchable to the activeSearchables state
         * @param state
         * @param {string} slug Searchable slug you want to push
         */
        pushSearchable(state, slug) {
            if (!state.activeSearchables.find(item => item === slug)) {
                state.activeSearchables.push(slug)
            }
        },

        /**
         * Removes a searchable from the activeSearchables state
         * @param state
         * @param {string} slug Searchable slug you want to remove
         */
        popSearchable(state, slug) {
            state.activeSearchables = state.activeSearchables.filter(item => item !== slug)
        },

        /**
         * Pushes a filter to the activeFilters state
         * @param state
         * @param {Object} filter Filter slug you want to push
         */
        pushFilter(state, filter) {
            const idx = state.activeFilters.findIndex(stateFilter => stateFilter[0] === filter.parent)
            if (idx === -1) {
                state.activeFilters.push([filter.parent, [filter.slug]])
            } else {
                if (!state.activeFilters[idx][1].find(activeFilter => activeFilter === filter.slug)) {
                    state.activeFilters[idx][1].push(filter.slug)
                }
            }
        },

        /**
         * Removes a filter from the activeFilters state
         * @param state
         * @param {object} filter Filter slug you want to remove
         */
        popFilter(state, filter) {
            const idx = state.activeFilters.findIndex(stateFilter => stateFilter[0] === filter.parent)
            if (idx === -1) return;
            state.activeFilters[idx][1] = [...state.activeFilters[idx][1].filter(item => item !== filter.slug)]
        },

        pushCategory(state, slug) {
            const idx = state.activeCategories.findIndex(item => item === slug)
            if (idx === -1) {
                state.activeCategories.push(slug)
            }
        },
        pushChef(state, slug) {
            const idx = state.activeChefs.findIndex(item => item === slug)
            if (idx === -1) {
                state.activeChefs.push(slug)
            }
        },
        pushProgram(state, slug) {
            const idx = state.activePrograms.findIndex(item => item === slug)
            if (idx === -1) {
                state.activePrograms.push(slug)
            }
        },
        pushBlog(state, slug) {
            const idx = state.activeBlog.findIndex(item => item === slug)
            if (idx === -1) {
                state.activeBlog.push(slug)
            }
        },

        popCategory(state, slug) {
            state.activeCategories = state.activeCategories.filter(item => item !== slug)
        },
        popChef(state, slug) {
            state.activeChefs = state.activeChefs.filter(item => item !== slug)
        },
        popProgram(state, slug) {
            state.activePrograms = state.activePrograms.filter(item => item !== slug)
        },
        popBlog(state, slug) {
            state.activeBlog = state.activeBlog.filter(item => item !== slug)
        },


        /**
         * Sets a certain filter active in the data state
         * @param state
         * @param {object} payload Filter object that contains categories
         */
        setActive(state, payload) {
            const filter = state.data.filters
                    .find(filter => filter.title === payload.parent)

            filter?.categories.map(child => {
                return child.slug === payload.slug ? {
                    ...child,
                    active: payload.active
                } : child
            })
        },

        /**
         * Builds the URL and pushes it to the history
         * @param state
         */
        buildURL(state) {
            if (!state.shouldChangeUrl) return;

            const searchables = state.activeSearchables.sort(sortStrings).join(',') || 'in-alle'
            // const categories = state.activeFilters.filter(filter=>filter[0]==='category').map(filter=> filter[1])?.at(0)?.sort(sortStrings).join(',') || 'alle-categorieen'
            // const chefs = state.activeFilters.filter(filter=>filter[0]==='chef').map(filter=> filter[1])?.at(0)?.sort(sortStrings).join(',') || 'alle-chefs'
            // const programs = state.activeFilters.filter(filter=>filter[0]==='program').map(filter=> filter[1])?.at(0)?.sort(sortStrings).join(',') || 'alle-programmas'

            const categories = state.activeCategories.sort(sortStrings).join(',') || 'alle-categorieen'
            const chefs = state.activeChefs.sort(sortStrings).join(',') || 'alle-chefs'
            const programs = state.activePrograms.sort(sortStrings).join(',') || 'alle-programmas'

            const query = {}
            if (state.text) query['q'] = state.text
            if (state.sorting) query['sort'] = state.sorting
            if (state.activeTab) query['tab'] = state.activeTab.slug
            if (state.page) query['page'] = state.page
            router.push({name: 'main', params: {searchables, categories, chefs, programs}, query})
        },

        /**
         * Builds a search query and updates the searchQuery state
         * @param state
         */
        buildQuery(state) {
            let searchablesString = ''
            if (state.activeSearchables.length > 0) {
                searchablesString = `&searchables[]=${state.activeSearchables.join('&searchables[]=')}`
            }
            let filterString = ''
            if (state.activeCategories.length > 0) filterString += `&filter[category][]=${state.activeCategories.join('&filter[category][]=')}`
            if (state.activeChefs.length > 0) filterString += `&filter[celeb][]=${state.activeChefs.join('&filter[celeb][]=')}`
            if (state.activePrograms.length > 0) filterString += `&filter[program][]=${state.activePrograms.join('&filter[program][]=')}`
            if (state.activeBlog.length > 0) filterString += `&filter[blog][]=${state.activeBlog.join('&filter[blog][]=')}`
            let sortingString = `sorting=${state.sorting}`

            const pageString = state.page ? `page=${state.page}` : ''
            const text = `q=${state.text}`
            // const tab = `&tab=${state.activeTab.slug ? state.activeTab.slug : state.activeSearchables[0]}`
            const tab = ``
            state.searchQuery = `?${text}${searchablesString}${filterString}&${sortingString}&${pageString}${tab !== '&tab=undefined' ? tab : ''}`
        },

        /**
         * Sets the fetchState.pending
         * @param state
         * @param {bool} pending
         */
        setFetchStatePending(state, pending) {
            state.fetchState.pending = pending;
        },

        /**
         * Sets the fetchState.error
         * @param state
         * @param {string} message
         */
        setFetchStateError(state, message) {
            state.fetchState.error = message
        },

        /**
         * Sets the sorting state
         * @param state
         * @param {string} slug
         */
        setSorting(state, slug) {
            state.sorting = slug
        },

        /**
         * Sets the activeFilters state
         * @param state
         * @param {string[]} newFilters
         */
        setActiveFilters(state, newFilters) {
            state.activeFilters = [...newFilters]
        },

        /**
         * Sets the activeSearchables state
         * @param state
         * @param {string[]} newSearchables
         */
        setActiveSearchables(state, newSearchables) {
            state.activeSearchables = [...newSearchables]
        },

        setShouldChangeUrl(state, value) {
            state.shouldChangeUrl = value
        },

        setPanelOpen(state, value) {
            state.panelOpen = value
        },


        /**
         * Clears the activeFilters state
         * @param state
         */
        emptyFilters(state) {
            state.activeFilters = []
        },

        /**
         * Set the page state
         * @param state
         * @param {number} page
         */
        setPage(state, page) {
            state.page = page
        },

        setText(state, text) {
            state.text = text
        },
        setTab(state, tab) {
            state.activeTab = tab
        }
    },
})

export default store